import React from 'react';
// 和样式相关的一些处理
export const getFontSize = (fontSize?: number) => {
  const oneStyle: React.CSSProperties = {};
  if (fontSize) {
    if (fontSize >= 12) {
      oneStyle.fontSize = fontSize;
    } else {
      oneStyle.fontSize = 12; // 这是最小的字体了
      oneStyle.transform = `scale(${fontSize / 12})`;
    }
  }
  return oneStyle;
};
